const hasPayOutTiers = tiers => {
  if (tiers && Object.keys(tiers).length > 0) {
    return true;
  }
  return false;
};

export { hasPayOutTiers as default };
